import * as React from "react";
const SvgFiRrFriday = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-friday_svg__a)">
      <path
        fill="#062147"
        d="M12.6 17.6v1.801h1.601a.8.8 0 1 1 0 1.6H12.6v2.2a.8.8 0 1 1-1.6 0v-6.4a.8.8 0 0 1 .8-.8h2.4a.8.8 0 1 1 0 1.6zM22.801 16a.8.8 0 0 0-.8.8v6.4a.8.8 0 1 0 1.6 0v-6.4a.8.8 0 0 0-.8-.8m1.2-9v6a1 1 0 1 1-2 0v-3H2v9c0 1.654 1.346 3 3 3h3a1 1 0 1 1 0 2H5c-2.757 0-5-2.243-5-5V7c0-2.757 2.243-5 5-5h1V1a1 1 0 1 1 2 0v1h8V1a1 1 0 1 1 2 0v1h1a5.007 5.007 0 0 1 5.001 5m-2 0c0-1.654-1.346-3-3-3H5C3.346 4 2 5.346 2 7v1h20zm-2.167 13.544c.024-.014.753 2.423.753 2.423A.8.8 0 0 1 19.822 24c-.356 0-.732-.235-.832-.576L18.285 21h-.784v2.2a.8.8 0 1 1-1.6 0v-6.4a.8.8 0 0 1 .8-.8h1.567c1.284 0 2.456.908 2.613 2.182a2.49 2.49 0 0 1-1.047 2.362m-.533-2.044c0-.496-.404-.9-.9-.9h-.9v1.8h.9c.496 0 .9-.404.9-.9"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-friday_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFriday;
